const firebaseConfig = {
    apiKey: "AIzaSyCNvFg98vn8Xu-__WvIlbjdDMwA22eAJi8",
    authDomain: "hr-dream-destination.firebaseapp.com",
    projectId: "hr-dream-destination",
    storageBucket: "hr-dream-destination.appspot.com",
    messagingSenderId: "693784393549",
    appId: "1:693784393549:web:4699a2f7b436d1bd3ce904"
};

export default firebaseConfig;